(() => {
  const storageKey = 'velora-favorite-products';

  const readFavorites = () => {
    try {
      return new Set(JSON.parse(localStorage.getItem(storageKey) || '[]'));
    } catch (error) {
      return new Set();
    }
  };

  const writeFavorites = (favorites) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...favorites]));
    } catch (error) {
      // Favorites remain usable for this visit when storage is unavailable.
    }
  };

  const favorites = readFavorites();

  const updateFavorite = (button, selected) => {
    const productTitle = button.dataset.veloraProductTitle || button.dataset.veloraFavorite.replace(/-/g, ' ');
    button.setAttribute('aria-pressed', String(selected));
    button.setAttribute(
      'aria-label',
      `${selected ? 'Quitar' : 'Agregar'} ${productTitle} ${selected ? 'de' : 'a'} favoritos`
    );
  };

  const initializeFavorites = (root = document) => {
    root.querySelectorAll('[data-velora-favorite]').forEach((button) => {
      updateFavorite(button, favorites.has(button.dataset.veloraFavorite));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-velora-favorite]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const product = button.dataset.veloraFavorite;
    const selected = !favorites.has(product);
    selected ? favorites.add(product) : favorites.delete(product);
    writeFavorites(favorites);
    updateFavorite(button, selected);
  });

  const animateProductToCart = (productForm) => {
    const cart = document.querySelector('.header__icon--cart');
    if (!cart) return;

    cart.classList.remove('is-velora-cart-bump');
    void cart.offsetWidth;
    cart.classList.add('is-velora-cart-bump');
    cart.addEventListener('animationend', () => cart.classList.remove('is-velora-cart-bump'), { once: true });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const productImage = productForm?.closest('product-info, .card-wrapper')?.querySelector(
      '.product__media img, .product-media-container img, .card__media img'
    );
    if (!productImage?.currentSrc && !productImage?.src) return;

    const sourceRect = productImage.getBoundingClientRect();
    const cartRect = cart.getBoundingClientRect();
    if (!sourceRect.width || !sourceRect.height || !cartRect.width || !cartRect.height) return;

    const flyer = document.createElement('img');
    flyer.src = productImage.currentSrc || productImage.src;
    flyer.alt = '';
    flyer.setAttribute('aria-hidden', 'true');
    Object.assign(flyer.style, {
      position: 'fixed',
      zIndex: '2147483647',
      left: `${sourceRect.left}px`,
      top: `${sourceRect.top}px`,
      width: `${sourceRect.width}px`,
      height: `${sourceRect.height}px`,
      objectFit: 'cover',
      borderRadius: '0.6rem',
      pointerEvents: 'none',
      willChange: 'transform, opacity',
    });
    document.body.appendChild(flyer);

    const translateX = cartRect.left + cartRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
    const translateY = cartRect.top + cartRect.height / 2 - (sourceRect.top + sourceRect.height / 2);
    flyer
      .animate(
        [
          { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 0.88 },
          { transform: `translate3d(${translateX}px, ${translateY}px, 0) scale(0.12)`, opacity: 0.15 },
        ],
        { duration: 420, easing: 'cubic-bezier(.22,.72,.16,1)' }
      )
      .finished.then(() => flyer.remove(), () => flyer.remove());
  };

  const start = () => {
    initializeFavorites();
    document.addEventListener('shopify:section:load', (event) => initializeFavorites(event.target));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source !== 'product-form') return;

        animateProductToCart(event.productForm);
      });
    }
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
